import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SharingService } from '../sharing/sharingservice.service';
import { MatIcon } from '@angular/material/icon';


@Component({
    // eslint:disable-next-line:component-selector
    selector: 'eca-header-base',
    standalone: true,
    imports: [MatIcon],
    templateUrl: './eca-header-base.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./eca-header-base.component.scss']
  })

export class EcaHeaderBaseComponent implements OnInit{
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private sharingService = inject(SharingService);


  helpLink = 'https://assets.drcedirect.com/Common/System_Status_Online_Help/index.htm#t=system_status_overview.htm';
  isAuthenticated = false;
  private subscriptions: Subscription[] = [];
  clientTitle: '';

  ngOnInit(){
    setInterval( () => {
      this.isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true' ? true : false;
      this.clientTitle = this.sharingService.getData();
    }, 1000);    
  }

  get showHelp(): boolean{
    return (this.isAuthenticated || (this.clientTitle != ''));
  }
  logOut(){
    sessionStorage.clear();
    this.logIn();
  }
  
  logIn(){
    const returnUrl = this.route.snapshot.queryParams['returnUrl'];
    if (returnUrl) {
      this.router.navigate(['/status/login'], { queryParams: { returnUrl: returnUrl }});
    } else {
      this.router.navigate(['/status/login']);
    }
  }

}
